/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCreateLineItem extends models.BillingRuleCreateLineItemBase {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCreateLineItem");
    }

    getFixupPrototypeFunction() { return BillingRuleCreateLineItem.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCreateLineItem>): BillingRuleCreateLineItem {
        let obj = Object.assign(new BillingRuleCreateLineItem(), model);
        BillingRuleCreateLineItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCreateLineItem>): BillingRuleCreateLineItem {
        if (!model) return null;
        return BillingRuleCreateLineItem.newInstance(<BillingRuleCreateLineItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCreateLineItem) {
        if (!obj) return;

        models.BillingRuleCreateLineItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCreateLineItem): boolean {
        if (models.BillingRuleCreateLineItemBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCreateLineItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.amount === undefined) {
            this.amount = 0;
        }
    }

    /**
     * Amount of the billing rule
     */
    amount: number;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
